import { useCallSessionContext } from "./CallSessionProvider";

export const useCallSession = () => {
  return useCallSessionContext();
};

export default useCallSession;
